import { makeActionCreator } from '../../../../../utilities'
import { RevisedTraumaScoreConstants } from './revisedTraumaScore.constants'

export const setRTSSysBp = makeActionCreator(RevisedTraumaScoreConstants.SET_RTS_BP, 'rtsBp')
export const setRTSRespRate = makeActionCreator(RevisedTraumaScoreConstants.SET_RTS_RESP, 'rtsResp')
export const setRTS = makeActionCreator(RevisedTraumaScoreConstants.SET_RTS, 'rts')
export const saveRTSData = makeActionCreator(RevisedTraumaScoreConstants.SAVE_RTS_DATA)
export const setRTSData = makeActionCreator(RevisedTraumaScoreConstants.SET_RTS_DATA, 'rtsData')
export const resetRTSData = makeActionCreator(RevisedTraumaScoreConstants.RESET_RTS_DATA)
